<template>
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-page-header :title="activityTitle" sub-title="活动参赛选手列表" @back="() => $router.back()">
      <template slot="extra">
        <!-- <a-button key="1" type="primary">
          导出
        </a-button> -->
      </template>
    </a-page-header>

    <a-form layout="inline" class="filter-form">
      <a-form-item label="选手昵称">
        <a-input v-model="queryForm.nick_name" placeholder="选手昵称" allowClear />
      </a-form-item>
      <a-form-item label="手机号">
        <a-input v-model="queryForm.phone" placeholder="手机号" allowClear />
      </a-form-item>
      <a-form-item label="编号">
        <a-input v-model="queryForm.sn" placeholder="编号" allowClear />
      </a-form-item>
      <!-- <a-form-item label="状态">
        <a-select v-model="queryForm.status" placeholder="状态" allowClear style="width: 160px;">
          <a-select-option value="1">已提交</a-select-option>
          <a-select-option value="2">已入选</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item label="报名时间">
        <a-range-picker v-model="queryForm.timeRange" format="YYYY-MM-DD" value-format="YYYY-MM-DD" allowClear
          style="width: 260px;" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearch" :loading="loading">搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button @click="handleReset">重置</a-button>
      </a-form-item>
    </a-form>

    <a-table :columns="columns" :data-source="list" :loading="loading" rowKey="activity_beauti_id" :pagination="false"
      :scroll="{ x: 1850 }" class="mt-20">
      <template slot="status" slot-scope="text">
        <a-tag v-if="text === '1'" color="orange">已提交</a-tag>
        <a-tag v-else-if="text === '2'" color="green">已入选</a-tag>
        <span v-else>--</span>
      </template>
      <template slot="is_show" slot-scope="text">
        <a-tag v-if="text === '1'" color="green">展示</a-tag>
        <a-tag v-else-if="text === '2'" color="red">不展示</a-tag>
        <span v-else>--</span>
      </template>
      <template slot="result" slot-scope="text">
        <a-tooltip :title="text">
          <span class="result-cell">{{ text || '--' }}</span>
        </a-tooltip>
      </template>
      <template slot="file_url" slot-scope="text">
        <img v-if="text" :src="text" alt="" width="50px" height="50px" style="cursor: pointer;object-fit: cover;" @click="preview(text)" />
        <a-tag v-else>未上传</a-tag>
      </template>
      <template slot="action" slot-scope="text, row">
        <a-button type="link" @click="handleEdit(row)">编辑</a-button>
        <a-button type="link" style="color: red;" @click="handleDelete(row)">删除</a-button>
      </template>
    </a-table>

    <!-- 编辑对话框 -->
    <a-modal
      title="编辑参赛选手"
      :visible="editVisible"
      @ok="handleEditOk"
      @cancel="handleEditCancel"
      :confirm-loading="editLoading"
      destroyOnClose
      :maskClosable="false"
      width="600px"
    >
      <a-form-model ref="editForm" :model="editForm" :rules="editRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="昵称" prop="nick_name">
          <a-input v-model="editForm.nick_name" placeholder="请输入昵称" />
        </a-form-model-item>
        <!-- <a-form-model-item label="入选状态" prop="status">
          <a-radio-group v-model="editForm.status">
            <a-radio value="1">已提交</a-radio>
            <a-radio value="2">已入选</a-radio>
          </a-radio-group>
        </a-form-model-item> -->
        <a-form-model-item label="是否展示" prop="is_show">
          <a-radio-group v-model="editForm.is_show">
            <a-radio value="1">展示</a-radio>
            <a-radio value="2">不展示</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <div class="pagination-bar">
      <a-pagination show-size-changer :current="page" :pageSize="limit" :total="total"
        :pageSizeOptions="['10', '20', '50', '100']" @change="handlePageChange" @showSizeChange="handleSizeChange"
        :show-total="total => `共 ${total} 条数据`" />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'ActivityParticipants',
  data() {
    return {
      activityId: '',
      activityTitle: '',
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      exportLoading: false,
      queryForm: {
        nick_name: '',
        phone: '',
        sn: '',
        status: undefined, //1已提交2已入选
        timeRange: [],
      },
      columns: [
        {
          title: '编号',
          dataIndex: 'sn',
          width: 120,
        },
        {
          title: '昵称',
          dataIndex: 'nick_name',
          width: 160,
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          width: 150,
        },
        {
          title: '参赛图片',
          dataIndex: 'file_url',
          scopedSlots: { customRender: 'file_url' },
          width: 120,
        },
        {
          title: '票数',
          dataIndex: 'vote_count',
          width: 100,
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 120,
        },
        {
          title: '是否展示',
          dataIndex: 'is_show',
          scopedSlots: { customRender: 'is_show' },
          width: 120,
        },
        {
          title: '风险等级',
          dataIndex: 'risk_level',
          width: 120,
        },
        {
          title: '检测结果',
          dataIndex: 'result',
          scopedSlots: { customRender: 'result' },
          width: 240,
        },
        {
          title: '报名时间',
          dataIndex: 'create_time',
          width: 180,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 200,
          fixed: 'right',
        },
      ],
      editVisible: false,
      editLoading: false,
      editForm: {
        uid: '',
        nick_name: '',
        status: '1',
        is_show: '1',
      },
      editRules: {
        nick_name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择入选状态', trigger: 'change' },
        ],
        is_show: [
          { required: true, message: '请选择是否展示', trigger: 'change' },
        ],
      },
    };
  },
  created() {
    this.initFromRoute();
    this.fetchData();
  },
  watch: {
    '$route'(to, from) {
      if (to.path === '/activity/participants') {
        this.initFromRoute();
        this.page = 1;
        this.limit = 10;
        this.fetchData();
      }
    }
  },
  methods: {
    preview(url) {
      this.$viewerApi({
        images: [url],
      });
    },
    initFromRoute() {
      const { activity_id, activity_title } = this.$route.query;
      if (!activity_id) {
        this.$message.error('缺少活动ID');
        this.handleBack();
        return;
      }
      this.activityId = activity_id;
      this.activityTitle = activity_title || '';
    },
    handleBack() {
      this.$router.back();
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleReset() {
      this.queryForm = {
        nick_name: '',
        phone: '',
        sn: '',
        status: '',
        timeRange: [],
      };
      this.page = 1;
      this.fetchData();
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchData();
    },
    handleSizeChange(current, size) {
      this.page = current;
      this.limit = size;
      this.fetchData();
    },
    handleExport() {
      this.$message.info('导出功能待实现');
    },
    handleEdit(row) {
      this.editForm = {
        id: row.id,
        nick_name: row.nick_name || '',
        status: row.status || '1',
        is_show: row.is_show || '1',
      };
      this.editVisible = true;
    },
    handleEditOk() {
      this.$refs.editForm.validate(valid => {
        if (!valid) {
          return false;
        }
        this.editLoading = true;
        this.$http({
          url: '/admin/activity/updateParticipant',
          method: 'post',
          data: this.editForm,
        }).then((res) => {
          if (res.code === 1) {
            this.$message.success('编辑成功');
            this.editVisible = false;
            this.fetchData();
          } else {
            this.$message.error(res.message || '编辑失败');
          }
        }).catch(() => {
          this.$message.error('编辑失败');
        }).finally(() => {
          this.editLoading = false;
        });
      });
    },
    handleEditCancel() {
      this.editVisible = false;
      this.$refs.editForm && this.$refs.editForm.resetFields();
    },
    handleDelete(row) {
      this.$confirm({
        title: '是否删除当前选择数据',
        content: '删除后不可恢复,请谨慎操作',
        okText: '确认删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.$http({
            url: '/admin/activity/deleteParticipant',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success('删除成功');
              this.fetchData();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          }).catch(() => {
            this.$message.error('删除失败');
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    fetchData() {
      if (!this.activityId) {
        return;
      }
      this.loading = true;
      const params = {
        activity_id: this.activityId,
        page: this.page,
        limit: this.limit,
        nick_name: this.queryForm.nick_name,
        phone: this.queryForm.phone,
        sn: this.queryForm.sn,
        status: this.queryForm.status,
      };
      if (this.queryForm.timeRange && this.queryForm.timeRange.length === 2) {
        params.start_time = `${this.queryForm.timeRange[0]} 00:00:00`;
        params.end_time = `${this.queryForm.timeRange[1]} 23:59:59`;
      }
      this.$http({
        url: '/admin/activity/participantPage',
        method: 'post',
        data: params,
      }).then((res) => {
        this.list = (res.data && res.data.result) || [];
        this.total = (res.data && res.data.total) || 0;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.header-bar .left {
  display: flex;
  align-items: center;
}

.header-bar .title {
  margin: 0 16px;
  font-weight: 600;
}

.header-bar .sub-title {
  color: #999;
}

.filter-form {
  background: #fafafa;
  padding: 12px 16px;
  border-radius: 8px;
}

.mt-20 {
  margin-top: 20px;
}

.pagination-bar {
  margin-top: 16px;
  text-align: right;
}

.result-cell {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
